import config from 'config'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import { fetchStoreDetails } from 'revenue/actions'
import { FETCH_ALL_STORES_SUCCESS } from 'revenue/constants'
import { fetchAction } from 'utils'

import * as actions from './actions'
import { SEARCH_FOR_STORES_LOGIC } from './constants'
import { getDetails, getSearchInputValue } from './selectors'

const fetchDetailsLogic = createLogic({
  type: [FETCH_ALL_STORES_SUCCESS],
  latest: true,

  async process({ getState, action }, dispatch, done) {
    try {
      const state = getState()
      const details = getDetails(state)

      if (details && details.storeId) {
        dispatch(
          fetchStoreDetails({
            ...action.payload,
            countryId: details.countryId,
          }),
        )
      }
    } catch (error) {
      // Not interested
    }

    done()
  },
})

const searchForStores = createLogic({
  type: SEARCH_FOR_STORES_LOGIC,
  latest: true,

  async process({ getState }, dispatch, done) {
    const state = getState()
    const searchInputValue = getSearchInputValue(state)
    const baseRequestParams = dateMenuSelectors.baseRequestParams(getState())

    if (searchInputValue.length > 2) {
      dispatch(actions.searchForStores())

      try {
        const response = await fetchAction(config.api.stores, {
          ...baseRequestParams,
          newOnly: false,
          ecoms: false,
          necoms: true,
          filter: searchInputValue || null,
        })
        dispatch(actions.searchForStoresSuccess(response.data))
      } catch (e) {
        dispatch(actions.searchForStoresError())
      }
    } else {
      dispatch(actions.searchForStoresError(`searchInputValue is to short (${searchInputValue.length})`))
    }

    done()
  },
})

export default [fetchDetailsLogic, searchForStores]
